import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vauth-page">
      <div className="vauth-left">
        <div className="vauth-left-glow"></div>
        <div className="vauth-left-glow2"></div>
        <div className="vauth-left-content">
          <img src="/logo.png" alt="Outsourced" className="vauth-logo-img" />
          <h1 className="vauth-brand-title">Outsourced</h1>
          <p className="vauth-brand-tagline">Premium Discord Server Boosts</p>
          <div className="vauth-features">
            <div className="vauth-feature">
              <div className="vauth-feature-icon">⚡</div>
              <div>
                <div className="vauth-feature-title">Instant Delivery</div>
                <div className="vauth-feature-desc">Boosts delivered automatically within seconds</div>
              </div>
            </div>
            <div className="vauth-feature">
              <div className="vauth-feature-icon">🛡️</div>
              <div>
                <div className="vauth-feature-title">Secure & Reliable</div>
                <div className="vauth-feature-desc">Crypto payments with full order tracking</div>
              </div>
            </div>
            <div className="vauth-feature">
              <div className="vauth-feature-icon">💰</div>
              <div>
                <div className="vauth-feature-title">Best Prices</div>
                <div className="vauth-feature-desc">Cheapest boosts on the market, guaranteed</div>
              </div>
            </div>
          </div>
        </div>
        <div className="vauth-left-footer">© 2025 Outsourced</div>
      </div>

      <div className="vauth-right">
        <div className="vauth-form-wrap">
          <div className="vauth-form-header">
            <h2 className="vauth-form-title">Reset password</h2>
            <p className="vauth-form-sub">Enter your email and we'll send a reset link</p>
          </div>

          {error && <div className="vauth-error">{error}</div>}

          {sent ? (
            <div className="vauth-success">
              <div className="vauth-success-icon">✓</div>
              <div className="vauth-success-title">Reset link sent</div>
              <div className="vauth-success-desc">Check your email inbox (and spam folder) for the password reset link.</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="vauth-field">
                <label>Email Address</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" required />
              </div>
              <button type="submit" className="vauth-submit" disabled={loading}>
                {loading ? <span className="vauth-spinner"></span> : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="vauth-divider"><span>or</span></div>

          <p className="vauth-switch">
            Remember your password? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
